// @flow

import type { Action } from '../types/actions/activity'

export const MENTOR_APPROVED_ACTIVITY = 'MENTOR_APPROVED_ACTIVITY'
export const MENTOR_REJECTED_ACTIVITY = 'MENTOR_REJECTED_ACTIVITY'
export const SHOW_NOTE_ARTIFACT_DELETED_MODAL =
  'SHOW_NOTE_ARTIFACT_DELETED_MODAL'
export const SET_NEW_ARTIFACT_ASSESSMENT_AVAILABLE_FALSE =
  'SET_NEW_ARTIFACT_ASSESSMENT_AVAILABLE_FALSE'

/** *********************************************************
 NOTE: MENTOR_APPROVED_ACTIVITY and MENTOR_REJECTED_ACTIVITY
 are handled in 3 separate reducers:
 1) currentactivity
 2) myquest
 3) myquests
 ********************************************************* **/

export function mentorApprovedActivity(
  activityId: number,
  approvedBy: Object
): Action {
  return {
    type: MENTOR_APPROVED_ACTIVITY,
    approvedBy: approvedBy,
    activityId: activityId
  }
}

export function mentorRejectedActivity(
  activityId: number,
  disapprovedBy: Object
): Action {
  return {
    type: MENTOR_REJECTED_ACTIVITY,
    disapprovedBy: disapprovedBy,
    activityId: activityId
  }
}
